module.exports = __webpack_public_path__ + "static/media/logo_reecall_2020.d2beb4e7.svg";